import { Layout, Row, Col, Image, Card } from "antd";
import logo from "@assets/SVG/logo.svg";

import styles from "./Layout.module.scss";

export const OnBoarding = (props: any) => {
  return (
    <Layout.Content
      style={{ height: "100%" }}
      className={styles.leftSideSection}
    >
      <Row style={{ height: "100%" }} align="middle">
        <Col
          xs={{ span: 24 }}
          md={{ span: 24 }}
          // className={styles.leftSideSection}
        >
          <div className={styles.onboardingContentWrapper}>
            <Row
              justify="center"
              align="middle"
              style={{
                marginTop: styles.whitespace3,
                marginBottom: styles.whitespace3,
                width: "100%",
              }}
            >
              <Col xs={{ span: 24 }} md={{ span: 18 }}>
                <Card
                  className={styles.cardStyle}
                  bodyStyle={{
                    width: "100%",
                    margin: "auto",
                    paddingBlock: styles.whitespace4,
                  }}
                >
                  {props.children}
                </Card>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Layout.Content>
  );
};
